<gipi-abstract>
    <gipi-toolbar id="toolbarListBackupFiles"
                  label="Lista de arquivos">
    </gipi-toolbar>

    <div fxLayout="column"
         fxLayoutGap="16px"
         style="overflow: hidden; height: 100%;">
        <div class="header">
            <h3 class="client"> {{ data.nameClient }} </h3>

            <div class="stats">
                <div class="stats-item">
                    <mat-icon svgIcon="backup_server"></mat-icon>
                    <span>{{ textQuantityBackup$ | async }}</span>
                </div>
                <div class="stats-item">
                    <mat-icon svgIcon="backup_database"></mat-icon>
                    <span>{{ textQuantitySize$ | async }}</span>
                </div>
            </div>
        </div>

        <div class="backup-list"
             *ngIf="((listBackup$ | async).length > 0) && !(loading$ | async)">
            <div class="backup-item"
                 *ngFor="let backup of (listBackup$ | async)">
                <div class="main-info">
                    <div class="file-info">
                        <mat-icon svgIcon="backup_zip"></mat-icon>

                        <div class="file-details">
                            <span>{{ extractFileName(backup.key) }}</span>
                            <p>{{ backup.key }}</p>
                        </div>
                    </div>
                    <a (click)="onHandleDownloadBackup(backup)"
                       class="download-btn"
                       *ngIf="validateAccess('ROLE_DEVELOPERS')">
                        <mat-icon svgIcon="backup_download"> </mat-icon>
                    </a>
                </div>
                <div class="secondary-info">
                    <div class="left-side">
                        <div class="info-item">
                            <mat-icon svgIcon="backup_date"></mat-icon>
                            <span>{{ formatDateTime(backup.lastModified) }}</span>
                        </div>
                        <div class="info-item">
                            <mat-icon svgIcon="backup_database"></mat-icon>
                            <span>{{ formatBytes(backup.size) }}</span>
                        </div>
                    </div>
                    <!-- <span class="etag">ETag: {{ backup.etag }}</span> -->
                </div>
            </div>
        </div>

        <div class="no-records"
             *ngIf="(listBackup$ | async).length <= 0 && !(loading$ | async)">
            <mat-icon>sentiment_very_dissatisfied</mat-icon>
            <span>Nenhum registro foi encontrado</span>
        </div>

        <gipi-progress-bar *ngIf="(loading$ | async)">
        </gipi-progress-bar>
    </div>

    <div mat-dialog-actions
         fxLayout="row"
         fxLayoutAlign="end end"
         fxLayoutGap="16px">
        <gipi-button label="Voltar"
                     gipi-secondary
                     id="btnReturn"
                     name="btnReturn"
                     (click)="close()"
                     fxFlex="20"
                     fxFlex.lt-md="100">
        </gipi-button>
    </div>
</gipi-abstract>